const componentId = 'Logo';

export const testIds = {
    LogoComponent: `${componentId}.LogoComponent`
};
